import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { Lists } from '~/api/scheme';
import { UpdateRelationsParams } from '~/api/scheme/lists';
import useListDialogs from '~/hooks/useListDialogs';
import useCreditValidator from '~/hooks/useCreditValidator';
import useCurrentUser from '~/hooks/useCurrentUser';

const useAddToListDialog = () => {
  const {
    addToListOpened,
    closeAddToListDialog,
    openCreateListDialog,
    lists,
    listsRefetch,
    selectedIds,
    selectedRows,
    onAddToListSuccessCallback,
    creatableListType,
  } = useListDialogs();

  const { enqueueSnackbar } = useSnackbar();
  const { validateCredits } = useCreditValidator();
  const { currentUser } = useCurrentUser();

  const mutation = useMutation((params: UpdateRelationsParams) => Lists.updateRelations(params), {
    onSuccess(response, variables) {
      listsRefetch();
      // TODO: Change callback API to (response, context)
      onAddToListSuccessCallback?.(response.data.updated, variables.relationships?.ids as string[]);
    },
    onError() {
      enqueueSnackbar('Something went wrong', { variant: 'error' });
    },
  });

  const [active, setActive] = useState<string | undefined>(undefined);

  // * Need to get rid of any dependencies, because it's stored in context's state
  // * Pass all required data via params
  // ! Rename to addToList
  const onAddToList = (listId: string, selectedIds: string[]) => {
    mutation.mutate({
      list_id: listId,
      relationships: {
        ids: selectedIds,
        method: 'associate',
      },
    });
  };

  const onClickList = (id: string, listId: string) => {
    setActive(id);
    if (creatableListType != 'OpportunityList') {
      onAddToList(listId, selectedIds);
    }
    setTimeout(() => {
      setActive(undefined);
    }, 100);
    setTimeout(() => {
      if (creatableListType === 'OpportunityList') {
        validateCredits(
          'list',
          listId,
          selectedRows,
          currentUser?.attributes.credits_amount || 0,
          1
        );
      } else {
        closeAddToListDialog();
      }
    }, 300);
  };

  return {
    agentLists: lists[creatableListType],
    onAddToList,
    active,
    onClickList,
    setActive,
    open: addToListOpened,
    onClose: closeAddToListDialog,
    openCreateListDialog,
  };
};

export default useAddToListDialog;
